import { handleActions } from 'redux-actions'

import actions from '@/actions'

import getTopicReducer from './reducers/getTopic.reducer'
import lecturesReducer from './reducers/lectures.reducer'
import progressReducer from './reducers/progress.reducer'

const initialState = {}

export default handleActions<any, any>(
  {
    ...lecturesReducer,
    ...getTopicReducer,
    ...progressReducer,
    [actions.lecture.clearAll]: () => initialState,
  },
  initialState,
)
